import { verify2FA } from "../../api/users";
import { EMAIL_2FA_VERIFICATION_RESULT } from "../../constants/error";
import {
  userConnection,
  userSignUp,
  userForgetPassword,
  loginAndHandleSuccess,
} from "../../redux/actions";

export const handleConnectionService = (
  dispatch,
  email,
  password,
  setPassword,
  setVerificationError,
) => {
  setPassword(password);
  setVerificationError("");

  dispatch(userConnection(email, password));
};

export const handleSignupService = (
  dispatch,
  email,
  password,
  nom,
  prenom,
  telephone,
  phoneObj,
  newsletter,
) => {
  dispatch(
    userSignUp(email, password, nom, prenom, telephone, phoneObj, newsletter),
  );
};
export const handleForgetPasswordService = (dispatch, email) => {
  dispatch(userForgetPassword(email));
};
const TERMINAL_VERIFICATION_ERRORS = [
  EMAIL_2FA_VERIFICATION_RESULT.MAX_ATTEMPTS_REACHED,
  EMAIL_2FA_VERIFICATION_RESULT.VERIFICATION_EXPIRED,
  EMAIL_2FA_VERIFICATION_RESULT.NO_PENDING_VERIFICATION,
];

export const handleVerificationError = (
  error,
  setVerificationError,
  setTime,
) => {
  const isTerminalError = TERMINAL_VERIFICATION_ERRORS.includes(
    error.errorName,
  );

  if (isTerminalError) {
    setTime(0);
  }

  setVerificationError(error.errorMessage);

  return isTerminalError;
};

export const handleVerifyCodeService = async (
  dispatch,
  verificationEmail,
  password,
  code,
  setVerificationError,
  setLoading,
  setTime,
) => {
  try {
    setLoading(true);
    setVerificationError("");

    const response = await verify2FA(verificationEmail, code);

    if (response?.verified) {
      dispatch(loginAndHandleSuccess(verificationEmail, password));

      return;
    }

    setVerificationError(response.message);
    setLoading(false);
  } catch (error) {
    handleVerificationError(error, setVerificationError, setTime);
    setLoading(false);
  }

  return false;
};

export const resendCodeService = (dispatch, verificationEmail, password) => {
  dispatch(userConnection(verificationEmail, password));
};
